module.exports = __webpack_public_path__ + "static/media/gray_12.1.736692f1.jpg";